var _excluded = ["size", "as"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { shouldForwardProp } from '../../utils';
import TextUtils from './TextUtils';
import { color, display } from 'styled-system';
import { strictSpace } from '../../utils/index';
import { screenReaderOnly } from '../Mixins/Mixins';
import styledPropTypes from '@styled-system/prop-types';

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: ".concat(n, ")");
};

export var getFontSize = function getFontSize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      size = _ref.size,
      theme = _ref.theme;

  if (!size) return;

  if (_typeof(size) === 'object') {
    //	https://github.com/styled-system/styled-system/blob/master/src/index.js#L62
    return Object.keys(size).map(function (breakpointKey) {
      var breakpoint = theme.breakpoints[breakpointKey];
      var media = createMediaQuery(breakpoint);
      if (breakpoint !== undefined) return _defineProperty({}, media, theme.fonts[size[breakpointKey]]);
    }).filter(Boolean);
  } else {
    return theme.fonts[size];
  }
};
/**
 * The base Text component from which all other text components inherit.
 * Text is by default a paragraph element.
 */

var Text = styled.p.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Text",
  componentId: "sc-jtvd3o-0"
})(["", " color:", ";", " ", " font-weight:", ";", ";font-family:", ";text-align:", ";", " ", " ", ";", ""], strictSpace, function (p) {
  return p.theme.colors.textSecondary;
}, color, display, function (props) {
  return props.fontWeight;
}, getFontSize, function (_ref3) {
  var font = _ref3.font,
      theme = _ref3.theme;
  return font || theme.fontFamilies.inter;
}, function (_ref4) {
  var align = _ref4.align;
  return align;
}, function (props) {
  return props.caps && 'text-transform: uppercase';
}, function (props) {
  return props.screenReaderOnly && screenReaderOnly;
}, function (props) {
  return props.lineClamp && css(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], props.lineClamp);
}, function (props) {
  return props.whiteSpace && "white-space: ".concat(props.whiteSpace);
});
Text.displayName = 'Text';
Text.propTypes = _objectSpread(_objectSpread(_objectSpread({
  /** Font family */
  font: PropTypes.string,

  /** Font size */
  size: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),

  /** Font weight */
  fontWeight: PropTypes.oneOf(['normal', 'bold']),

  /** Manually sets the text alignment */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /** Hide text visually but make it accessible for screen readers */
  screenReaderOnly: PropTypes.bool
}, styledPropTypes.space), {}, {
  /** color can reference any of the [color variables](/#/Variables?id=colors) */
  color: PropTypes.string
}, styledPropTypes.color), {}, {
  /** limit text to a certain number of lines, with ellipses added if lines overflow */
  lineClamp: PropTypes.number,

  /** Corresponds to the white-space CSS property */
  whiteSpace: PropTypes.string
});
Text.defaultProps = {
  size: 'body',
  fontWeight: 'normal',
  align: 'inherit',
  mt: 'none',
  mb: 'none'
};
export var Title = function Title(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    fontWeight: "bold",
    color: "textPrimary",
    as: "h4",
    size: "body"
  }, props));
};
Text.Title = Title;
export var Subtitle = function Subtitle(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    fontWeight: "bold",
    as: "h5",
    size: "small"
  }, props));
};
Text.Subtitle = Subtitle;
export var BodySmall = function BodySmall(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    size: "small"
  }, props));
};
Text.BodySmall = BodySmall;
export var Caption = function Caption(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    size: "caption"
  }, props));
};
Text.Caption = Caption;
export var Tagline = function Tagline(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    size: "caption",
    fontWeight: "bold",
    color: "textPrimary"
  }, props));
};
Text.Tagline = Tagline; // -----------------------------------------------------------------------------
// Headings
// -----------------------------------------------------------------------------

var Heading = styled(Text).withConfig({
  displayName: "Text__Heading",
  componentId: "sc-jtvd3o-1"
})(["text-rendering:optimizeLegibility;font-family:", ";"], function (_ref5) {
  var font = _ref5.font,
      theme = _ref5.theme;
  return font || theme.fontFamilies.riforma;
});
Heading.displayName = 'Heading';
Heading.defaultProps = {
  as: 'h3',
  size: '3',
  color: 'textPrimary',
  fontWeight: 'bold',
  mt: 'none',
  mb: 'none'
};
export var mergeSize = function mergeSize(defaultSize, size) {
  if (!size) return defaultSize;

  if (_typeof(size) === 'object') {
    return _objectSpread({
      mobile: defaultSize
    }, size);
  }

  return size;
};

var createHeading = function createHeading(defaultSize, base) {
  return function (_ref6) {
    var size = _ref6.size,
        as = _ref6.as,
        restProps = _objectWithoutProperties(_ref6, _excluded);

    return /*#__PURE__*/React.createElement(Heading, _extends({
      as: as || base,
      size: mergeSize(defaultSize, size)
    }, restProps));
  };
}; // H1 defaults to size 2 since it's the most common pattern used


export var H1 = createHeading(2, 'h1');
export var H2 = createHeading(2, 'h2');
export var H3 = createHeading(3, 'h3');
export var H4 = createHeading(4, 'h4');
export var H5 = createHeading(5, 'h5');
export var H6 = createHeading(6, 'h6');
Text.H1 = H1;
Text.H2 = H2;
Text.H3 = H3;
Text.H4 = H4;
Text.H5 = H5;
Text.H6 = H6;
export var Display = function Display(props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "span",
    size: "1"
  }, props));
};
Text.Display = Display; // -----------------------------------------------------------------------------
// Text Utilities as static properties
// -----------------------------------------------------------------------------

Text.Highlight = TextUtils.Highlight;
Text.Normal = TextUtils.Normal;
Text.Uppercase = TextUtils.Uppercase;
Text.Lowercase = TextUtils.Lowercase;
Text.Capitalize = TextUtils.Capitalize;
Text.Sup = TextUtils.Sup;
Text.Right = TextUtils.Right;
Text.Left = TextUtils.Left;
Text.Center = TextUtils.Center; // Paragraph component alias for convenience

export var P = Text;
Text.P = P;
/** @component */

export default Text;